var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("div", { staticClass: "table-wrapper" }, [
        _vm.isEdit
          ? _c("div", { staticClass: "table-caption" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("lease.linkedLeases")) + "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("table", [
          _c("thead", [
            _c(
              "tr",
              [
                _vm._l(_vm.itemHeaders, function (header, index) {
                  return header.code !== "leaseEnd"
                    ? _c(
                        "th",
                        {
                          key: index,
                          class: "sort_header " + header.name,
                          on: {
                            click: function ($event) {
                              return _vm.sortBy(header.code)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(header.name) +
                              " " +
                              _vm._s(
                                _vm.orderbyAttr === header.code
                                  ? _vm.reverse
                                    ? "▼"
                                    : "▲"
                                  : null
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.isEdit ? _c("th") : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.linkedLeases, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [_vm._v(_vm._s(item.id))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.premises))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.buildAbbr))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.$t("lease.leaseName." + item.leaseTypeDesc))
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.tradeName))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.formatYN(item.active)))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      (item.leaseStart &&
                        _vm.dateUtil.formatDate(item.leaseStart)) ||
                        "--"
                    )
                  ),
                ]),
                _vm._v(" "),
                _vm.isEdit && _vm.isCurrentCompanyLease(item.id)
                  ? _c("td", { staticClass: "icon-remove" }, [
                      _c("i", {
                        staticClass: "fa fa-times-thin",
                        on: {
                          click: function ($event) {
                            return _vm.removeFromTenancy(item)
                          },
                        },
                      }),
                    ])
                  : _vm.isEdit
                  ? _c("td")
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isEdit
        ? _c("div", { staticClass: "table-wrapper" }, [
            _c("div", { staticClass: "table-caption" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("lease.allCompanyLeases")) + "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("table", [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th"),
                    _vm._v(" "),
                    _vm._l(_vm.itemHeaders, function (header, index) {
                      return _c(
                        "th",
                        {
                          key: index,
                          class: "sort_header " + header.class,
                          on: {
                            click: function ($event) {
                              return _vm.sortAllBy(header.code)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(header.name) +
                              " " +
                              _vm._s(
                                _vm.orderAllByAttr === header.code
                                  ? _vm.reverseAll
                                    ? "▼"
                                    : "▲"
                                  : null
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.companyLeases, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _c("input", {
                        key: "lease-key-" + _vm.leaseKey,
                        staticClass: "checkbox",
                        class: { "disable-checkbox": _vm.isChecked(item) },
                        attrs: {
                          type: "checkbox",
                          disabled: _vm.isChecked(item),
                        },
                        domProps: { checked: _vm.isChecked(item) },
                        on: {
                          change: function (event) {
                            return _vm.addToTenancy(item, event.target.checked)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.id))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.premises))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.buildAbbr))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.$t("lease.leaseName." + item.leaseTypeDesc))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.tradeName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.formatYN(item.active)))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          (item.leaseStart &&
                            _vm.dateUtil.formatDate(item.leaseStart)) ||
                            "--"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          (item.leaseEnd &&
                            _vm.dateUtil.formatDate(item.leaseEnd)) ||
                            "--"
                        )
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "confirmLinkModal",
          attrs: { modalId: "confirm-link-modal", showCloseBtn: false },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-pure-text",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenancy.unmatched.warning")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { id: "confirm_no", type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.cancelAddLease()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { id: "confirm_yes", type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.doAddLease()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.continue")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }